<template>
  <div class="d-flex align-center justify-end">
    <slot name="prepend"></slot>

    <v-menu offset-y v-if="show">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="display" elevation="0" v-bind="attrs" v-on="on" class="dropdown-menu-btn pa-0 ml-2">
          <v-icon color="colorGrey" size="14" class="fi fi-rr-angle-small-down"></v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <slot name="list"></slot>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'TableDropdown',
  props: {
    show: {
      type: Boolean,
      default: true,
      required: false,
    },
    display: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
}
</script>
